export default "__VITE_ASSET__Ckpyj9$A__"